module.exports = __webpack_public_path__ + "img/logo-proAct.5fc13d74.svg";